<div id="container">
    <aside class="sidebar lft">
        <a href="#" id="hamburger" title="{{ 'common.menu' | translate }}" class="mobi">
            <span class="burger">
                <i class="top"></i>
                <i class="middle"></i>
                <i class="bottom"></i>
            </span>
            <span class="text">{{ 'common.menu' | translate }}</span>
        </a>

        <app-menu activeElement="downloads"></app-menu>
    </aside>
    <div id="inner">
        <main class="page">
            <div class="page-card">
                <h1>{{ 'screens.downloads.title' | translate }}</h1>

                <section>
                    <h2>{{ 'screens.downloads.energyReport.title' | translate }}</h2>
                    <p>{{ 'screens.downloads.energyReport.description' | translate }}</p>

                    <div class="action-group">
                        <button
                            class="eon-button-new"
                            (click)="openEnergyReport()"
                            [disabled]="downloadService.isEnergyReportLoading$ | async">
                            {{ 'screens.downloads.energyReport.openButton' | translate }}
                        </button>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.export.title' | translate }}</h2>
                    <p>{{ 'screens.downloads.export.description' | translate }}</p>

                    <div class="export-controls">
                        <div class="month-selector">
                            <div class="eon-dropdown">
                                <select
                                    id="monthSelect"
                                    [(ngModel)]="selectedMonth">
                                    <option
                                        *ngFor="let month of availableMonths"
                                        [value]="month.value">
                                        {{ month.label }}
                                    </option>
                                </select>
                                <span></span>
                            </div>
                        </div>

                        <div class="action-group">
                            <button
                                class="eon-button-new"
                                (click)="exportConsumptionData()"
                                [disabled]="(downloadService.isExportLoading$ | async) || !selectedMonth">
                                <i *ngIf="downloadService.isExportLoading$ | async" class="spinner-sm"></i>
                                {{ 'screens.downloads.export.downloadButton' | translate }}
                            </button>
                        </div>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.exportToThirdParties.title' | translate }}</h2>
                    <p>
                        {{ 'screens.downloads.exportToThirdParties.description' | translate }}
                        <a href="https://www.eon.de/de/pk/hems/eu-data-act.html" target="_blank" rel="noopener noreferrer">
                            {{ 'screens.downloads.exportToThirdParties.descriptionLink' | translate }}
                        </a>.
                    </p>

                    <div class="action-group">
                        <button
                            class="eon-button-new"
                            (click)="exportToThirdParties()"
                            [disabled]="downloadService.isThirdPartyExportLoading$ | async">
                            <i *ngIf="downloadService.isThirdPartyExportLoading$ | async" class="spinner-sm"></i>
                            {{ 'screens.downloads.exportToThirdParties.button' | translate }}
                        </button>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.gdprExport.title' | translate }}</h2>
                    <p>{{ 'screens.downloads.gdprExport.description' | translate }}</p>

                    <div class="action-group">
                        <button
                            class="eon-button-new"
                            (click)="exportGdprData()"
                            [disabled]="downloadService.isGdprExportLoading$ | async">
                            <i *ngIf="downloadService.isGdprExportLoading$ | async" class="spinner-sm"></i>
                            {{ 'screens.downloads.gdprExport.button' | translate }}
                        </button>
                    </div>
                </section>

                <section>
                    <h2>{{ 'screens.downloads.transparencyDeclaration.title' | translate }}</h2>
                    <p>
                        {{ 'screens.downloads.transparencyDeclaration.description' | translate }}
                        <a href="https://www.eon.de/content/dam/eon/eon-de-zwei/documents/Privatkunden/smart-control/eon-smart-control-transparenzerkl%C3%A4rung.pdf" target="_blank" rel="noopener noreferrer">
                            {{ 'screens.downloads.transparencyDeclaration.descriptionLink' | translate }}
                        </a>.
                    </p>
                </section>
            </div>
        </main>
    </div>
</div>
